import React, { useState, useEffect } from 'react';
import { doc, updateDoc, deleteDoc, getDoc } from 'firebase/firestore';
import { firestore } from '../views/firebaseConfig';

const BusinessPostEdit = ({ tournamentId, onClose }) => {
  const [formData, setFormData] = useState({
    title: '', description: '', fee: '', rules: '', numPlayers: '', prize: '', ballType: '', date: '', time: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const snap = await getDoc(doc(firestore, 'tournaments', tournamentId));
        if (snap.exists()) {
          const data = snap.data();
          const dt = data.dateTime.toDate();
          setFormData({
            title: data.title,
            description: data.description,
            fee: data.fee,
            rules: data.rules,
            numPlayers: data.numPlayers?.toString() || '',
            prize: data.prize,
            ballType: data.ballType,
            date: dt.toISOString().slice(0, 10),
            time: dt.toISOString().slice(11, 16)
          });
        }
        setLoading(false);
      } catch (err) {
        setError('Failed to load event.');
        setLoading(false);
      }
    };
    fetchEvent();
  }, [tournamentId]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleUpdate = async () => {
    const { date, time, ...rest } = formData;
    const newDateTime = new Date(`${date}T${time}`);
    try {
      await updateDoc(doc(firestore, 'tournaments', tournamentId), {
        ...rest,
        numPlayers: parseInt(rest.numPlayers),
        dateTime: newDateTime
      });
      onClose();
    } catch (err) {
      setError('Failed to update event.');
    }
  };

  const handleDelete = async () => {
    try {
      await deleteDoc(doc(firestore, 'tournaments', tournamentId));
      onClose();
    } catch (err) {
      setError('Failed to delete event.');
    }
  };

  if (loading) return <div className="p-3 text-white">Loading...</div>;

  return (
    <div className="p-4 bg-dark text-white">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Edit Event</h5>
        <button onClick={onClose} className="btn-close btn-close-white"></button>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {['title', 'description', 'fee', 'rules', 'numPlayers', 'prize', 'ballType'].map(field => (
        <div className="form-group mb-2" key={field}>
          <label className="text-capitalize">{field}</label>
          {field === 'description' ? (
            <textarea name={field} value={formData[field]} onChange={handleChange} className="form-control" />
          ) : (
            <input name={field} value={formData[field]} onChange={handleChange} className="form-control" />
          )}
        </div>
      ))}
      <div className="form-group mb-2">
        <label>Date</label>
        <input type="date" name="date" value={formData.date} onChange={handleChange} className="form-control" />
      </div>
      <div className="form-group mb-4">
        <label>Time</label>
        <input type="time" name="time" value={formData.time} onChange={handleChange} className="form-control" />
      </div>
      <div className="d-flex justify-content-between">
        <button onClick={handleDelete} className="btn btn-danger">Delete</button>
        <button onClick={handleUpdate} className="btn btn-primary">Save</button>
      </div>
    </div>
  );
};

export default BusinessPostEdit;

